var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCountry(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.5 5L17.033 6.1C16.6868 6.35964 16.2657 6.5 15.833 6.5H12.475C12.1496 6.50013 11.8322 6.60086 11.5662 6.78839C11.3003 6.97592 11.0988 7.24109 10.9894 7.54756C10.8801 7.85404 10.8681 8.18684 10.9552 8.50038C11.0423 8.81392 11.2242 9.09286 11.476 9.299L13.476 10.935C14.2506 11.5688 14.8544 12.3862 15.2324 13.313C15.6103 14.2397 15.7505 15.2463 15.64 16.241L15.62 16.421C15.5404 17.137 15.3645 17.839 15.097 18.508L14.5 20M1.5 9.5L4.738 8.96C5.05209 8.90757 5.37415 8.9309 5.67741 9.02804C5.98067 9.12518 6.25634 9.29333 6.48151 9.51849C6.70668 9.74366 6.87482 10.0193 6.97196 10.3226C7.0691 10.6258 7.09243 10.9479 7.04 11.262L6.905 12.069C6.78781 12.773 6.89939 13.496 7.22336 14.1318C7.54733 14.7677 8.06662 15.283 8.705 15.602C9.21425 15.8568 9.62137 16.2777 9.85918 16.7951C10.097 17.3125 10.1512 17.8956 10.013 18.448L9.5 20.5",
    stroke: "#E02126",
    strokeWidth: 1.25
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11 20.5C16.2467 20.5 20.5 16.2467 20.5 11C20.5 5.75329 16.2467 1.5 11 1.5C5.75329 1.5 1.5 5.75329 1.5 11C1.5 16.2467 5.75329 20.5 11 20.5Z",
    stroke: "#E02126",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCountry);
export default __webpack_public_path__ + "static/media/country.c1e48fad66c7b3accbbd79fad23b5048.svg";
export { ForwardRef as ReactComponent };